import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { ChatProvider } from './contexts/ChatContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Home from './pages/Home';
import AgencyList from './pages/AgencyList';
import AgencyDetails from './pages/AgencyDetails';
import RocketList from './pages/RocketList';
import RocketDetails from './pages/RocketDetails';
import LaunchList from './pages/LaunchList';
import LaunchDetails from './pages/LaunchDetails';
import ScientistList from './pages/ScientistList';
import ScientistDetails from './pages/ScientistDetails';
import SatelliteList from './pages/SatelliteList';
import SatelliteDetails from './pages/SatelliteDetails';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import ArticleList from './pages/ArticleList';
import ArticleDetails from './pages/ArticleDetails';
import CreateArticle from './pages/CreateArticle';
import NewsList from './pages/NewsList';
import NewsDetails from './pages/NewsDetails';
import Chat from './pages/Chat';
import Marketplace from './pages/Marketplace';
import BookDetails from './pages/BookDetails';
import PhysicsLab from './pages/PhysicsLab';

/**
 * Main App Component
 * Sets up routing and context providers
 */
function App() {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <ChatProvider>
            <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
              <Navbar />
              
              <main style={{ flex: 1 }}>
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<Home />} />
                  
                  {/* Agency Routes */}
                  <Route path="/agencies" element={<AgencyList />} />
                  <Route path="/agencies/:id" element={<AgencyDetails />} />
                  
                  {/* Rocket Routes */}
                  <Route path="/rockets" element={<RocketList />} />
                  <Route path="/rockets/:id" element={<RocketDetails />} />
                  
                  {/* Launch Routes */}
                  <Route path="/launches" element={<LaunchList />} />
                  <Route path="/launches/:id" element={<LaunchDetails />} />
                  
                  {/* Scientist Routes */}
                  <Route path="/scientists" element={<ScientistList />} />
                  <Route path="/scientists/:id" element={<ScientistDetails />} />
                  
                  {/* Satellite Routes */}
                  <Route path="/satellites" element={<SatelliteList />} />
                  <Route path="/satellites/:id" element={<SatelliteDetails />} />
                  
                  {/* Article Routes */}
                  <Route path="/articles" element={<ArticleList />} />
                  <Route path="/articles/:id" element={<ArticleDetails />} />
                  <Route 
                    path="/articles/create" 
                    element={
                      <ProtectedRoute requireSubscription={true}>
                        <CreateArticle />
                      </ProtectedRoute>
                    } 
                  />
                  
                  {/* News Routes */}
                  <Route path="/news" element={<NewsList />} />
                  <Route path="/news/:id" element={<NewsDetails />} />
                  
                  {/* Marketplace Routes */}
                  <Route path="/marketplace" element={<Marketplace />} />
                  <Route path="/marketplace/:id" element={<BookDetails />} />
                  
                  {/* Physics Lab Route */}
                  <Route path="/physics-lab" element={<PhysicsLab />} />
                  
                  {/* Auth Routes */}
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route 
                    path="/profile" 
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    } 
                  />
                  
                  {/* Subscription Routes */}
                  <Route path="/subscription" element={<Subscription />} />
                  
                  {/* Chat Routes */}
                  <Route 
                    path="/chat" 
                    element={
                      <ProtectedRoute requireSubscription={true}>
                        <Chat />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/chat/:roomId" 
                    element={
                      <ProtectedRoute requireSubscription={true}>
                        <Chat />
                      </ProtectedRoute>
                    } 
                  />
                  
                  {/* 404 Route */}
                  <Route path="*" element={
                    <div className="container" style={{ paddingTop: '100px', textAlign: 'center' }}>
                      <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>404</h1>
                      <p style={{ fontSize: '18px', marginBottom: '30px', color: 'var(--text-dark)' }}>
                        Page not found
                      </p>
                      <a href="/" className="btn btn-primary">Go Home</a>
                    </div>
                  } />
                </Routes>
              </main>
              
              <Footer />
            </div>
          </ChatProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
